import React, { useEffect, useState } from "react";
import img from "../assets/images/sidom/fotos/pinS.png";
import logoNaranja from "../assets/images/sidom/fotos/SIDOM-LOGO_NARANJA.png";
import FormHosb from "./FormHubSpot";

export default function DashboardLayout({ children, user }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showDescargas, setShowDescargas] = useState(
    window.location.hash === "#descargas"
  );
  const [showHistorial, setShowHistorial] = useState(
    window.location.hash === "#historial"
  );
  const [showCalendario, setShowCalendario] = useState(
    window.location.hash === "#calendario"
  );
  const [showFormulario, setShowFormulario] = useState(
    window.location.hash === "#formulario"
  );
  const linksDeDescarga = [
    {
      nombre: "PwC",
      url: "https://drive.google.com/drive/folders/1aKy1hhW6RI9ZKII1kQPiDiiRW46g81es?usp=drive_link",
    },
    {
      nombre: "Presentación",
      url: "https://drive.google.com/drive/folders/1GNDsVj-xkeWH5w7bivvP7C_gk5j46NJ3?usp=drive_link",
    },
  ];

  useEffect(() => {
    const onHashChange = () => {
      setShowDescargas(window.location.hash === "#descargas");
      setShowHistorial(window.location.hash === "#historial");
      setShowCalendario(window.location.hash === "#calendario");
      setShowFormulario(window.location.hash === "#formulario");
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return (
    <div className="min-h-screen bg-sidom-light dark:bg-gray-900">
      {/* Botón para abrir/cerrar sidebar en mobile */}
      <button
        data-drawer-target="default-sidebar"
        data-drawer-toggle="default-sidebar"
        aria-controls="default-sidebar"
        type="button"
        className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        <span className="sr-only">Open sidebar</span>
        <svg
          className="w-6 h-6"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            clipRule="evenodd"
            fillRule="evenodd"
            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
          />
        </svg>
      </button>

      {/* Sidebar */}
      <aside
        id="default-sidebar"
        className={`fixed top-0 left-0 z-40 w-64 h-screen transition-transform ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } sm:translate-x-0 bg-sidom-gray dark:bg-gray-800`}
        aria-label="Sidebar"
      >
        <div className="h-full flex flex-col px-3 py-4 overflow-y-auto">
          <ul className="space-y-2 font-medium flex-1">
            <li>
              <button
                type="button"
                className="w-full flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group"
              >
                <div>
                  <img src={img} alt="Logo" className="w-6 h-6" />
                </div>
                <span className="ms-3">Dashboard</span>
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`w-full flex items-center p-2 rounded-lg group ${
                  showFormulario
                    ? "bg-gray-200 dark:bg-gray-700 text-sidom-orange dark:text-blue-400"
                    : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                }`}
                onClick={() => {
                  window.location.hash = "#formulario";
                }}
              >
                {/* SVG de formulario (icono de documento) */}
                <svg
                  className="w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:group-hover:text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.828A2 2 0 0 0 19.414 7.414l-4.828-4.828A2 2 0 0 0 12.172 2H6z"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 6h8M8 10h8M8 14h4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="ms-3">Formulario</span>
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`w-full flex items-center p-2 rounded-lg group ${
                  showHistorial
                    ? "bg-gray-200 dark:bg-gray-700 text-sidom-orange dark:text-blue-400"
                    : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                }`}
                onClick={() => {
                  window.location.hash = "#historial";
                }}
              >
                {/* SVG de historial (reloj) */}
                <svg
                  className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    d="M12 8v4l3 3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                </svg>
                <span className=" ms-3">Historial</span>
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`w-full flex items-center p-2 rounded-lg group ${
                  showCalendario
                    ? "bg-gray-200 dark:bg-gray-700 text-sidom-orange dark:text-blue-400"
                    : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                }`}
                onClick={() => {
                  window.location.hash = "#calendario";
                }}
              >
                <svg
                  className="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <rect
                    x="3"
                    y="8"
                    width="18"
                    height="13"
                    rx="2"
                    stroke="currentColor"
                    strokeWidth="1.5"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16 3v4M8 3v4M3 12h18"
                  />
                </svg>
                <span className="ms-3">Calendario</span>
              </button>
            </li>
            <li>
              <button
                type="button"
                className={`w-full flex items-center p-2 rounded-lg group ${
                  showDescargas
                    ? "bg-gray-200 dark:bg-gray-700 text-sidom-orange "
                    : "text-gray-900 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700"
                }`}
                onClick={() => {
                  window.location.hash = "#descargas";
                }}
              >
                {/* SVG de descarga actualizado */}
                <svg
                  className="w-5 h-5 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:group-hover:text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 4v12m0 0l-4-4m4 4l4-4M4 20h16"
                  />
                </svg>
                <span className="ms-3">Descargas</span>
              </button>
            </li>
          </ul>
          <div className="flex  items-start justify-center ">
            <img src={logoNaranja} alt="SIDOM Logo" className="w-32  h-auto " />
          </div>

          {/* Botón de cerrar sesión abajo */}
          <div className="mt-auto pt-4 flex flex-col items-center gap-4">
            <button
              type="button"
              onClick={() => {
                localStorage.removeItem("jwt");
                localStorage.removeItem("username");
                window.location.href =
                  "https://web.institucional.global.sidom.io/";
              }}
              className="w-full flex items-center p-2 text-sidom-orange rounded-lg hover:bg-red-50 dark:hover:bg-gray-700 group font-semibold"
            >
              <svg
                className="w-5 h-5 text-sidom-orange group-hover:text-sidom-orange transition duration-75"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H7a2 2 0 01-2-2V7a2 2 0 012-2h4a2 2 0 012 2v1"
                />
              </svg>
              <span className=" ms-3 ">Cerrar sesión</span>
            </button>
          </div>
        </div>
      </aside>

      <div className="p-4 sm:ml-64">
        <div className="mb-4 ">
          <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">
            !Hola
            {user ? `, ${user}` : ""} 👋
          </h2>
        </div>

        {showDescargas ? (
          <div className="mb-8">
            <h2 className="text-xl font-semibold mb-2 text-sidom-dark dark:text-white">
              Descargas
            </h2>
            <ul className="list-disc pl-5">
              {linksDeDescarga.map((link, idx) => (
                <li key={idx} className="mb-2">
                  <a
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sidom-dark underline hover:text-sidom-orange"
                  >
                    {link.nombre}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : showFormulario ? (
          <div className="mb-8">
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-white">
                Formulario de HubSpot
              </h2>
              <div className="bg-white dark:bg-gray-900 p-4 rounded shadow">
                <p className="text-gray-500">
                  <FormHosb />
                </p>
              </div>
            </section>
          </div>
        ) : showHistorial ? (
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
              Historial
            </h1>
            <div className="bg-white dark:bg-gray-900 p-6 rounded shadow">
              <p className="text-gray-600 dark:text-gray-300">
                Aquí podrás ver el historial de tus actividades.
              </p>
              {/* Aquí puedes agregar la lógica/listado de historial */}
            </div>
          </div>
        ) : showCalendario ? (
          <div className="mb-8">
            <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
              Calendario
            </h1>
            <div className="bg-white dark:bg-gray-900 p-6 rounded shadow">
              <p className="text-gray-600 dark:text-gray-300">
                Aquí podrás ver tus eventos y actividades en el calendario.
              </p>
              {/* Aquí puedes agregar la lógica/listado de calendario */}
            </div>
          </div>
        ) : (
          <div className="p-4 border-2 border-gray-200 border-dashed rounded-lg dark:border-gray-700">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
